module.exports = __webpack_public_path__ + "static/media/manage_schedulers.a982a6a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/manage_schedulers.svg
// module id = 2709
// module chunks = 0